import React, { Component } from 'react';
import { MARKETING_MODAL, PAYROLL_MODAL } from '../../redux/reducers/modal';
import DateManagementContent from '../blocks/management/DateManagementContent';
import MarketingStatsModal from '../blocks/marketing/MarketingStatsModal';
import ReduxModal from '../blocks/modal/ReduxModal';
import MainNav from '../blocks/navigation/MainNav';
import PayrollGeneratorModal from '../blocks/payroll/PayrollGeneratorModal';
import type { DateManagementProps } from '../../types';

class DateManagement extends Component<DateManagementProps> {
  handlePayrollGeneratorClick = () => {
    const { onOpenModal } = this.props;
    onOpenModal({ id: PAYROLL_MODAL });
  };

  handlePayrollModalClose = () => {
    const { onCloseModal } = this.props;
    onCloseModal({ id: PAYROLL_MODAL });
  };

  handleMarketingStatsClick = () => {
    const { onOpenModal } = this.props;
    onOpenModal({ id: MARKETING_MODAL });
  };

  handleMarketingModalClose = () => {
    const { onCloseModal } = this.props;
    onCloseModal({ id: MARKETING_MODAL });
  };

  render(): React.ReactNode {
    const { currentUser, router } = this.props;

    return (
      <div className="container-view vacation-management-view view-wrapper has-custom-table">
        <MainNav
          currentUser={currentUser}
          navigate={router.navigate}
          onPayrollGeneratorClick={this.handlePayrollGeneratorClick}
          onMarketingStatsClick={this.handleMarketingStatsClick}
        />
        <DateManagementContent
          {...this.props}
        />
        <ReduxModal id={PAYROLL_MODAL}>
          <PayrollGeneratorModal
            onCloseModal={this.handlePayrollModalClose}
          />
        </ReduxModal>
        <ReduxModal id={MARKETING_MODAL}>
          <MarketingStatsModal
            onCloseModal={this.handleMarketingModalClose}
          />
        </ReduxModal>
      </div>
    );
  }
}

export default DateManagement;
